module.exports = __webpack_public_path__ + "static/costs-2016.6e9bd4d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/exhibit5/costs-2016.png
// module id = 1391
// module chunks = 140525810354349